import { type ReactNode } from 'react'
import useAuthStore from '@/stores/useAuthStore'
import usePermissionsStore from '@/stores/usePermissionsStore'
import ErrorPage from '@/components/ErrorBoundary/ErrorPage'
import { toolsNav } from '../../nav'

const PartnerConsoleAccessGuard = ({ children }: { children: ReactNode }) => {
    const isAdmin = usePermissionsStore((state) => state.isAdmin)
    const departmentId = useAuthStore((state) => state.employee?.department_id)
    const allowed =
        isAdmin ||
        (departmentId !== undefined &&
            toolsNav.wafFreeReport.allowed_department_ids.some(
                (allowedDepartmentId) => allowedDepartmentId === departmentId
            ))

    return allowed ? children : <ErrorPage status={403} />
}

export default PartnerConsoleAccessGuard
